module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.is-object.js
// module id = 161
// module chunks = 0